"use client";

import { usePathname } from "next/navigation";
import type { ReactNode } from "react";

/**
 * The public site's header, footer, cookie banner and AVI chat must not
 * render inside the private /admin panel. One check here instead of
 * restructuring the app into route groups.
 */
export default function PublicChrome({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  if (pathname?.startsWith("/admin")) return null;
  return <>{children}</>;
}
